import gql from 'graphql-tag'

export default gql`
  fragment ObservationLearningRecords on Observation {
    learningRecords {
      ageGroupId
      childFkey
      outcomeId
      rankId
    }
  }
`
